import Box from '@mui/material/Box';
import { t } from '@/lib/strings';

interface LogoProps {
  /** Rendered height in px. Width follows the 500 x 195.96 viewBox. */
  height?: number;
  /**
   * True when the same words already appear in adjacent text, so a screen reader would
   * otherwise announce "TDC Erhverv" twice.
   */
  decorative?: boolean;
}

/**
 * The TDC Erhverv primary logo.
 *
 * The file is copied into web/public rather than imported across repos or pulled from a CDN —
 * the same reasoning as the theme (docs/beslutninger/2026-08-21-tdc-tema.md), and doubly so for
 * a tool that measures other people's supplier dependencies. The CSP allows `img-src 'self'`
 * only, so a remote logo would be blocked in any case.
 */
export function Logo({ height = 32, decorative = false }: LogoProps) {
  return (
    <Box
      component="img"
      src="/tdc-erhverv-logo.svg"
      alt={decorative ? '' : t('app.logoAlt')}
      sx={{
        height,
        width: 'auto',
        display: 'block',
        // The customer prints the report themselves; browsers drop background colour by
        // default, and a logo that prints as a grey block is worse than none.
        printColorAdjust: 'exact',
        WebkitPrintColorAdjust: 'exact',
      }}
    />
  );
}
